import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaBuilding, FaPhoneAlt, FaClock } from 'react-icons/fa';

const OurBranches = () => {
    const { t } = useTranslation();

    const branches = [
        {
            id: 1,
            nameKey: 'branches.list.main.name',
            addressKey: 'branches.list.main.address',
            phoneKey: 'branches.list.main.phone',
            timingKey: 'branches.list.main.timing',
            type: 'main'
        },
        {
            id: 2,
            nameKey: 'branches.list.branch1.name',
            addressKey: 'branches.list.branch1.address',
            phoneKey: 'branches.list.branch1.phone',
            timingKey: 'branches.list.branch1.timing',
            type: 'branch'
        },
        {
            id: 3,
            nameKey: 'branches.list.branch2.name',
            addressKey: 'branches.list.branch2.address',
            phoneKey: 'branches.list.branch2.phone',
            timingKey: 'branches.list.branch2.timing',
            type: 'branch'
        }
    ];

    return (
        <section className="py-20 bg-primary text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16">
                    <span className="text-secondary font-bold tracking-widest uppercase text-xs mb-3 block">{t('about.presenceBadge')}</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t('branches.title')}</h2>
                    <p className="text-blue-100 max-w-2xl mx-auto">{t('branches.subtitle')}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {branches.map((branch) => (
                        <div key={branch.id} className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/10 hover:bg-white/20 transition-all duration-300">
                            {branch.type === 'main' && (
                                <span className="bg-secondary text-white text-xs font-bold px-2 py-1 rounded mb-4 inline-block">{t('branches.mainOffice')}</span>
                            )}
                            <h3 className="text-xl font-bold text-white mb-4">{t(branch.nameKey)}</h3>
                            <div className="space-y-3 text-blue-100">
                                <div className="flex items-start gap-3">
                                    <FaBuilding className="mt-1 flex-shrink-0" />
                                    <p className="text-sm">{t(branch.addressKey)}</p>
                                </div>
                                <div className="flex items-center gap-3">
                                    <FaPhoneAlt className="flex-shrink-0" />
                                    <p className="text-sm">
                                        {t(branch.phoneKey).split(',').map((num, idx) => {
                                            const trimmedNum = num.trim();
                                            const dialableNum = trimmedNum.replace(/[^\d+]/g, '');
                                            return (
                                                <React.Fragment key={idx}>
                                                    {idx > 0 && <span className="text-blue-100">, </span>}
                                                    <a href={`tel:${dialableNum}`} className="hover:text-secondary transition-colors">
                                                        {trimmedNum}
                                                    </a>
                                                </React.Fragment>
                                            );
                                        })}
                                    </p>
                                </div>
                                <div className="flex items-center gap-3">
                                    <FaClock className="flex-shrink-0" />
                                    <p className="text-sm">{t(branch.timingKey)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurBranches;
